// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"0d5ba228","160":"8d4c9c37","208":"252ad1d7","293":"49fe0192","516":"021e0511","519":"6d1b5e10","917":"9df8bd95","946":"0f6a4299"}[chunkId] + ".chunk.js";
};